import Table from "../../components/Table/Table"
import ModalPopup from "../../components/ModalPopup/ModalPopup"
import { ButtonStyles, ModalPopupSize } from "../../lib/enums"
import { SiteDesignsInitialization } from "./SiteDesignsInitialization"
import ValidationMessage from "../../components/ValidationMessage/ValidationMessage"
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb"

const SiteDesigns = () => {
    const {
        projectId,
        projectName,
        siteId,
        siteName,        
        siteDesignsData,
        handleAddSiteDesign,
        handleDeleteSiteDesignRow,
        handleDuplicateSiteDesignRow,
        handleModalConfirmSiteDesignDeletion,
        handleModalCancelSiteDesignDeletion,
        siteDesignsTableColumns,
        showModal,
        maxNameLength,
        hasNameError,
        handleValidationMessageCloseEvent
    } = SiteDesignsInitialization()

    return (
        <div className="container msds-block-padding-small">
            <div className="row">
                <div className="col-12">
                    <Breadcrumb
                        projectId={projectId}
                        projectName={projectName}
                        siteId={siteId}
                        siteName={siteName} />
                </div>
                <h1 className="msds-text-header-1">{siteName}</h1>
                {hasNameError && (
                    <ValidationMessage
                        message={'Unable to post site design as the name must be under ' + maxNameLength + ' characters.'}
                        handleCloseEvent={handleValidationMessageCloseEvent}
                    />
                )}
                {siteDesignsData && (
                    <div className="col-12">
                        <Table
                            data={siteDesignsData}
                            columns={siteDesignsTableColumns}
                            addButtonLabel="Add New Site Design"
                            addButtonLabelIcon="plus"
                            onAddButtonClick={handleAddSiteDesign}
                            handleDeleteDataRow={handleDeleteSiteDesignRow}
                            handleDuplicateRow={handleDuplicateSiteDesignRow}
                            customCssClasses='msds-table--site-designs'
                        />
                        <ModalPopup
                            headline="Confirm Delete"
                            description="Are you sure you want to delete this row?"
                            size={ModalPopupSize.Small}
                            showModal={showModal}
                            onCloseButtonclick={handleModalCancelSiteDesignDeletion}
                            button1Style={ButtonStyles.Danger}
                            button1Label="Yes, delete"
                            button1OnClickHandler={handleModalConfirmSiteDesignDeletion}
                            button2Style={ButtonStyles.Tertiary}
                            button2Label="Cancel"
                            button2OnClickHandler={handleModalCancelSiteDesignDeletion}
                        />
                    </div>
                )}               
            </div>
        </div>
    );
};

export default SiteDesigns;
